import ReportController from './report.controller';

export default class GroupPaxReportController extends ReportController
{
	get endpoint() {
		return 'group-pax';
	}

	get title() {
		return 'Group Pax Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/group-pax.report.controller.js
 **/